export default {
    namespaced: true,
    state: {
        cache: {}   // { routeName: { page, pageSize, filters, scrollTop } }
    },
    mutations: {
        save(state, { routeName, data }) {
            state.cache[routeName] = data
        },
        remove(state, routeName) {
            delete state.cache[routeName]
        }
    }
}